import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className='d-flex justify-content-between text-white py-2' style={{ flexWrap: 'wrap', background: '#001427' }}>
            <div className='d-flex pt-3'>
                <Link className='mx-4' to='/terms-and-conditions' style={{ textDecoration: 'none', color: '#FFFFFF' }}>Terms & Condition</Link>
                <Link to='/privacypolicy' style={{ textDecoration: 'none', color: '#FFFFFF' }}>Privacy Policy</Link>
            </div>
            <div className='pt-3'>
                <p className='mx-4 '>@copyright 2022 vaultus.io</p>
            </div>
        </div>
    );
};

export default Footer;